import React, { Component, useEffect, useLayoutEffect, useRef, useState } from 'react';
import { TabView, TabPanel } from 'primereact/tabview';
import { Toolbar } from 'primereact/toolbar';
import FilterBox from '../../common/FilterBox';
import { Button } from 'primereact/button';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import { difficultyOptions, itemTypes, optionCounts } from '../../common/const';
import QueGrid from './QueGrid';
import { QuePreview } from './QuePreview';
import { Panel } from 'primereact/panel';
import CatTreeSelect, { CatSelectDialog } from '../../cat/CatTreeSelect';
import { QueProps } from './QueProps';
import CatSelect from '../../cat/CatSelect';
import { Card } from 'primereact/card';
import { InputTextarea } from 'primereact/inputtextarea';
import CmsService from '../../../service/CmsService';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHourglass } from '@fortawesome/free-solid-svg-icons';
import { useTranslation } from 'react-i18next';
import { Messages } from 'primereact/messages';

export function QueGridPageLink()
{
    let {id} = useParams();
    const navigate = useNavigate();

    useEffect(()=>{
        console.log('QueGridPageLink id:'+id);
    },[]);
    return (<QueGridPage mode="select" id={id} nav={navigate}/>)
}
export function QueGridPageAddToTestLink()
{
    let {id} = useParams();
    let [searchParams] = useSearchParams();
    const testId=searchParams.get("testId");
    const sectId=searchParams.get("sectId");

    const navigate = useNavigate();
    return (<QueGridPage mode="addToTest" id={id} testId={testId} sectId={sectId} nav={navigate}/>)
}
export function QueGridPage({id,mode,testId,sectId,nav}){
    const {t}=useTranslation();
    const [catId,setCatId]=useState(id);
    const [filterBar,setFilterBar]=useState({fb_itemtype:'ALL',fb_options:'ALL',fb_difficulty:'ALL'});
    const [query,setQuery]=useState({});
    const [currentQue,setCurrentQue]=useState({});
    const [commentBox,setCommentBox]=useState(false);
    const [comment,setComment]=useState("");
    const messages = useRef([]);
    const ancestorRef = useRef(null);
    const [ancestorRect,setAncestorRect ] = useState(null);

    const itemTypeOptions=()=>{
        var it=itemTypes.map((item)=>{return {label:t('QuestionType.'+item.value),value:item.value}});
        it=[{label: t('ALL'), value: 'ALL'},...it];
        return it;
    }
    const diffOptions=()=>{
        var it=difficultyOptions.map((item)=>{return {label:t('@difficulty.'+item.value),value:item.value}});
        return it;
    }
    const optCounts=()=>{
        let oc=[...optionCounts];
        oc[0].label=t(oc[0].label);
        return oc;
    }
    useLayoutEffect(() => {
        if (!ancestorRef.current) return;

        const observer = new ResizeObserver(() => {
        if (ancestorRef.current) {
            // Share the bounding coordinates globally
            setAncestorRect(ancestorRef.current.getBoundingClientRect());
        }
        });

        observer.observe(ancestorRef.current);
        return () => observer.disconnect();
    }, [setAncestorRect]);
    
    const onFilterBarChange=(inputId,value)=>{
        var fb={...filterBar};
        fb[inputId]=value;
        setFilterBar(fb);        
        runQuery(fb);
    }
    const runQuery=(fb)=>{
        if(catId == 0)
            return;
        setQuery({catId:catId,itemType:fb.fb_itemtype,options:fb.fb_options,difficulty:fb.fb_difficulty});
    }
    const onCatSelect=(cat)=>{
        setCatId(cat.id);
    }
    const filterBarStart=()=>{
        return (
            <div className="flex flex-none flex-wrap align-items-center gap-4 col-12 p-toolbar">
                <div className="w-full"><CatSelect parentId={0} value={catId} onSelect={onCatSelect}/></div>
                <FilterBox inputId="fb_itemtype" small items={itemTypeOptions()} value={filterBar.fb_itemtype} label={t('Question_Type')} onChange={onFilterBarChange}/>
                <FilterBox inputId="fb_options" small items={optCounts()} value={filterBar.fb_options} label={t('Options')} onChange={onFilterBarChange}/>
                <FilterBox inputId="fb_difficulty" small items={diffOptions()} value={filterBar.fb_difficulty} label={t('Difficulty')} onChange={onFilterBarChange}/>
            </div>
        );
    }
    const filterBarEnd=()=>{
        return (<></>);
        /*return (
            <div className="flex align-items-center gap-4">
                <Button onClick={this.runQuery}>Query</Button>
            </div>
        );*/
    }
    const questionIcons=()=>{
        var tbContent=[];
        if(currentQue.id!=undefined)
        {
            if(currentQue.locked)
                tbContent.push(<i className="pi pi-lock"></i>);
            else
                tbContent.push(<i className="pi pi-lock-open"/>);
            if(currentQue.approved)
                tbContent.push(<i className="pi pi-check"></i>);
            if(currentQue.pending)
                tbContent.push(<FontAwesomeIcon icon={faHourglass}/>);
        }
        return( 
            <div className='flex gap-2'>
            {tbContent}
            </div>
        )
    }    
    const previewPanelHeader=()=>{
        return(
            <div className="flex justify-content-between flex-wrap p-toolbar">
                <div className="flex gap-4">
                    <label>{currentQue.id>0?t('Question')+': '+currentQue.id:t('Question_not_selected')}</label>
                    <div>{questionIcons()}</div>
                    {currentQue.parentId!=undefined?<label>{t('Question_Group')}: {currentQue.groupName}</label>:''}
                </div>
                {currentQue.id>0?
                    <div className="flex gap-1">
                        <Button label={t('Edit')} icon="pi pi-pencil" onClick={onEdit}/>
                        <Button label={t('Comment')} icon="pi pi-comment" onClick={onReview}/>
                    </div>:<></>}
            </div>
        );
    }  
    const onEdit=()=>{
        nav('/itembank/question/'+currentQue.id);
    }
    const onReview=()=>{
        //nav('/itembank/question/'+currentQue.id+'/review');
        setCommentBox(true);
        setComment("");
    }
    const onSendComment=()=>{
        var rev={wrkId:null,
            objId:currentQue.id,
            message:comment,
            reviewType:'COMMENT',
            status:'COMMENT'};
        CmsService.reviewQuestion(rev.objId,rev).then((ret)=>{
            setCommentBox(false);
        });
    }
    const selectionChanged=(rec)=>{
        console.log("QueGridPage:selectionChanged:"+rec.id);
        setCurrentQue(rec);
    }  
    const showError=(err) => {
		messages.current.show({ severity: 'error', summary: t('error'), detail: t('@error.'+err)});
	}	
    return(
            <>
            <div className="p-card p-card-content p-3 col-12 shadow-1" ref={ancestorRef} style={{height:'calc(100vh - 80px)'}}>
                <div className="grid">
                <div className="col-4 xl:col-6 flex flex-column">
                    {filterBarStart()}
                    <div className=''>
                        <Messages ref={messages}></Messages> 
                        <QueGrid mode={mode} testId={testId} sectId={sectId} 
                                catId={catId} query={query} nav={nav}  
                                selectionChanged={selectionChanged} ancestorRect={ancestorRect} showError={showError}>
                        </QueGrid>
                    </div>
                </div>
                <Panel className="col-8 xl:col-6 flex flex-column" header={''} headerTemplate={previewPanelHeader}>                                                                
                    {commentBox?
                    <>
                        <div className="col-12 flex flex-column gap-2 mb-2">
                            <InputTextarea autoResize value={comment} onChange={(e) => setComment(e.target.value)} rows={5} cols={30} className="w-full" placeholder={t('Write_message_here')}/>
                            <Button icon="pi pi-send" label={t('Send')} onClick={onSendComment} style={{width:'80px'}}></Button>
                        </div>
                    </>:<></>
                    }
                    {currentQue.id>0?
                    <>
                        <QueProps question={currentQue}/>
                        <QuePreview id={currentQue.id} ancestorRect={ancestorRect}/>
                    </>:<></>
                    }
                </Panel>
                </div>
            </div>
            </>
        )
}

export default QueGridPage;
